module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vleg4-5a34eb763c05a53cbb4f25ab20e1371e.jpg";